// https://wordpress.stackexchange.com/questions/306813/check-password-strength-using-wordpress-api
import React, { 
  useState, 
  useEffect, 
  useRef 
} from 'react'
import { CloudUploadOutlined } from '@ant-design/icons'
import { 
  useParams,
  useNavigate
} from 'react-router-dom'
import AvatarEditor from 'react-avatar-editor'
import { useAvatar, useUser } from 'data/hooks'
import updatingicon from 'assets/icons/unicons/cloud-upload.svg'
import home from 'assets/icons/unicons/home-alt.svg'
import {
  Button,
  Form,
  Input
} from 'antd';
import {
  fetchCore
} from 'data/controls'
import { useTranslation } from 'react-i18next'

const { 
  RangeControl, 
  FormFileUpload,
  Disabled
} = wp.components

export const UserProfile = props => {

  const { t } = useTranslation(['user-profile'])
  const navigate = useNavigate()

  const editorref = useRef()
  const { setTitle, onProfileChanged } = props
  const gameId = useParams().gameId || playmotiv.game?.gameId
  const { userId } = useUser()
  const { avatar, uploadAvatar } = useAvatar(gameId, userId)

  const [zoom, setZoom] = useState(1)
  const [position, setPosition] = useState({ x: 0, y: 0 })
  const [image, setImage] = useState(avatar)
  const [updating, setUpdating] = useState(false)
  const [changed, setChanged] = useState(false)
  const [error, setError] = useState(null)
  const [changepasswordvalid, setChangepasswordvalid] = useState(false) 
  const [changepasswordresult, setChangepasswordresult] = useState('')   
  const [changepasswordresultclass, setChangepasswordresultclass] = useState('')  
  const [form] = Form.useForm();

  const imageChanged = e => {

    setImage(e.target.files[0])
    setChanged(true)
    setZoom(1)
  }

  const upload = () => {

    setUpdating(true)
    setError()

    setTimeout(() => {

      editorref.current
      .getImage()
      .toBlob(
        blob => {

          uploadAvatar(blob)
          .then(() => {
            setUpdating(false)
            setChanged(false)
            // dispatch(gameWPUsersRefresh())
            if (onProfileChanged) onProfileChanged()
          })

        }, 
        'image/jpeg', 
        1
      )

    }, 1000)
  }

  const onValuesChange = (changedValues, allValues) => {
    
    setChangepasswordresultclass('')
    setChangepasswordresult('')

    form.validateFields()
    .catch(errorinfo => {

      if(errorinfo.errorFields.length == 0) {

        setChangepasswordvalid(true)

      } else {

        setChangepasswordvalid(false)
      }
    })
  }

  const onFinish = values => {

    form.resetFields()
    setChangepasswordvalid(false)
    
    fetchCore(
      '/changepassword',
      {
        method: 'POST',
        body: {
          userid: userId,
          previouspassword: values.previouspassword,
          password: values.password
        }
      }
    )
    .then(result => {

      if(result == 'OK') {

        setChangepasswordresultclass('success')
        setChangepasswordresult('Se ha cambiado la contraseña')

      } else {                        
      
        setChangepasswordresultclass('error')
        setChangepasswordresult('Ha habido algún problema cambiando la contraseña')
      }
    })
  }
  
  useEffect(() => {
    
    setImage(avatar)

  }, [avatar])

  useEffect(() => {

    if (setTitle) setTitle('Perfil de usuario')

  }, [])

  return (
    <div className="user-profile">
      <div className="title">
        {
          props.backpath ?
          <img 
            src={
              props.backicon ?
              props.backicon
              :
              home
            }
            onClick={ () => navigate(props.backpath)}
          />
          :
          <></>
        }
        {
          props.title ?
          props.title
          :
          t('user-profile:Avatar')
        }
      </div>
      <div className="profile">
        <div className="upload">
          <FormFileUpload
            disabled={ updating }
            accept="image/*"
            onChange={imageChanged}
            className={`
              ant-btn 
              css-dev-only-do-not-override-bdlpt1 
              ant-btn-default
              ${ updating ? 'disabled' : '' }
            `}
          >
            {t('user-profile:profile.selectImage')}
          </FormFileUpload>
          <div className="image-info">
            {t('user-profile:profile.format')}
          </div>
        </div>
        <div className="editor">
          <div className="image">
            <div className="canvas">
              <AvatarEditor
                ref={editorref}
                image={image}
                width={160}
                height={160}
                border={0}
                color={[255, 255, 255, 0.6]} // RGBA
                scale={zoom}
                position={position}
                onPositionChange={position => { setPosition(position); setChanged(true) }}
              />
            </div>
          </div>
        </div>
        <div className="controls">
          <RangeControl
            label={t('user-profile:profile.escalado')}
            value={zoom}
            onChange={value => { setZoom(value), setChanged(true) }}
            withInputField={false}
            step={0.1}
            min={1}
            max={5}
            type="stepper"
          />
        </div>
        <div className="save">
          {
            error &&
            <div className="Error">
              {error}
            </div>
          }
          {
            updating ?
            <div className="uploading-icon">
              <CloudUploadOutlined size={128}/>
            </div>
            :
            <Button
              className={`${changed ? '' : 'NotChanged'}`}
              type="primary"
              onClick={upload}
              disabled={!changed}
            >
              {t('user-profile:profile.actualizar')}
            </Button> 
          }
          {
            <div className="uploading-message">
              {
                updating ?
                  t('user-profile:profile.actualizando')
                  :
                  ''
              }
            </div>
          }
        </div>
        <div
          className="back"
          onClick={ () => navigate('../') }
        />
      </div>
      <div className="changepassword">
        <div className="title">
          {t('user-profile:changePassword.title')}
        </div>
        <Form 
          className="form"
          form={ form }
          name="form"
          onFinish={ onFinish }
          onValuesChange={ onValuesChange }
        >
          <Form.Item
            name="previouspassword"
            label={t("user-profile:changePassword.actual")}
            rules={[
              {
                required: true,
                validator: (rule, value, cb) => {

                  const P = new Promise((resolve, reject) => {     

                    if(!value) {

                      return reject(new Error(t('user-profile:changePassword.writeActual')))
                    }     
                      
                    fetchCore(
                      '/checkpassword',
                      {
                        method: 'POST',
                        body: {
                          userid: userId,
                          password: value
                        }
                      }
                    )
                    .then(result => {

                      if(result == 'OK') {

                        resolve()

                      } else {                        
                      
                        reject(new Error(t('user-profile:changePassword.wrongPassword')))
                      }
                    })
                  })

                  return P
                }
              }
            ]}
            hasFeedback
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="password"
            label={t("user-profile:changePassword.nueva")}
            rules={[
              {
                required: true,
                validator: (rule, value, cb) => {

                  if(!value || value.length < 8) {

                    return Promise.reject(new Error(t('user-profile:changePassword.min8')));
                  }   

                  const previouspassword = form.getFieldValue('previouspassword')   

                  if(value == previouspassword) {

                    return Promise.reject(new Error(t('user-profile:changePassword.diferent')));
                  }      

                  const strength = wp.passwordStrength.meter(value || '', []) 

                  switch(strength) {

                    case 1:
                    case 2:

                      return Promise.reject(new Error(t('user-profile:changePassword.lowSecurity')));

                    /*

                    case 3:

                      return Promise.reject(new Error('La seguridad de contraseña es media'));

                    case 4:

                      return Promise.reject(new Error('La contraseña es fuerte'));
                    */
                  }

                  return Promise.resolve();
                }
              }
            ]}
            hasFeedback
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="confirm"
            label={t("user-profile:changePassword.confirm")}
            dependencies={['password']}
            hasFeedback
            rules={[
              {
                required: true,
                validator: (rule, value, cb) => {

                  if (!value) {

                    return Promise.reject(new Error(t('user-profile:changePassword.repeatNewPassword')));
                  }

                  const password = form.getFieldValue('password')

                  if(password === value) {

                    return Promise.resolve();
                  }

                  return Promise.reject(new Error(t('user-profile:changePassword.noCoincide')));
                }
              }
            ]}
          >
            <Input.Password />
          </Form.Item>
          <div 
            className={`
              changepasswordresult
              ${ changepasswordresultclass }
            `}
          >
            { changepasswordresult }
          </div>
          <Form.Item
            className={`
              submitbutton
              ${ changepasswordresultclass }
            `}
          >
            <Button 
              type="primary" 
              htmlType="submit"
              disabled={ !changepasswordvalid }
            >
              {t('user-profile:changePassword.changePassword')}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}
